import styled from 'styled-components'

const LabelStyle = styled.div`
    display: flex;
    margin-left: 10px;
    ${({ theme }) => theme.fonts.Karla['s16-ln20-fw400']};
`

export default LabelStyle
